import React from 'react';

// Values from ShortList, used in API v2
export const MILITARY_STATUS_VALUES = Object.freeze({
  VETERAN: 'Veteran of U.S. Armed Forces',
  NOT_VETERAN: 'Not a Veteran',
  NOT_DISCLOSED: 'I Prefer to Not Disclose'
});

// Values from ShortList, used in API v2
export const YEARS_OF_EXPERIENCE_VALUES = Object.freeze({
  LVL_1: 'Entry Level 0 - 2 Years',
  LVL_2: 'Intermediate 2 - 5 Years',
  LVL_3: 'Expert 5 - 10 Years',
  LVL_4: 'Management 10+ Years'
});

export const TRAINING_LEVEL = Object.freeze({
  BOOTCAMP: 'Path to Pro Skills Program',
  ACC_TRAIN_PGM: 'Accredited Training Program',
  NOT_DISCLOSED: 'I Prefer to Not Disclose',
  NOT_APPLICABLE: 'Not Applicable',
  BEHR_TRAINING_PGM: 'Behr Paint Curriculum'
});

// Values from ShortList, used in API v2
export const EDUCATION_LEVEL_VALUES = Object.freeze({
  NOT_DISCLOSED: 'I Prefer to Not Disclose',
  SOME_HIGH_SCHOOL: 'Some High School',
  HIGH_SCHOOL: 'High School Diploma or Equivalent',
  ACC_TRAIN_PGM: 'Accredited Training Program',
  ASSOC_DEG: 'Associate\'s Degree',
  BACH_DEG: 'Bachelor\'s Degree',
  MAST_DEG: 'Master\'s Degree',
  DOC: 'Doctorate'
});

export const validEducationLevels = [
  EDUCATION_LEVEL_VALUES.ASSOC_DEG,
  EDUCATION_LEVEL_VALUES.BACH_DEG,
  EDUCATION_LEVEL_VALUES.MAST_DEG,
  EDUCATION_LEVEL_VALUES.DOC
];

export const TERMS_CONDITIONS_LINK = 'https://www.homedepot.com/c/path-to-pro-network-terms-conditions';

export const LEARN_MORE_LINK = 'https://www.pathtopro.com/free-training';

export const EXP_ROUTES = {
  LANDING: '/path-to-pro-network',
  LANDING2: '/network',
  MY_DASHBOARD: '/path-to-pro-network/dashboard',
  CANDIDATE_SEARCH: '/path-to-pro-network/search',
  JOB_POSTINGS: '/path-to-pro-network/job-postings',
  JOB_TEMPLATES: '/path-to-pro-network/job-templates',
  JOB_TEMPLATE: (jobTemplateId) => `/path-to-pro-network/job-templates/${jobTemplateId}`,
  CREATE_JOB_POSTING: '/path-to-pro-network/job-postings/create',
  EDIT_JOB_POSTING: (jobPostingId, preview = false) => `/path-to-pro-network/job-postings/${jobPostingId}/edit${preview ? '?mode=preview' : ''}`,
  JOB_APPLICANTS: (jobPostingId) => `/path-to-pro-network/job-postings/${jobPostingId}/applicants`,
  JOB_POSTING: (jobPostingId) => `/path-to-pro-network/job-postings/${jobPostingId}`,
  COMPANY_PROFILE: '/path-to-pro-network/company-profile',
  JOB_RECOMMENDED: (jobPostingId) => `/path-to-pro-network/job-postings/${jobPostingId}/recommended`,
  // Below are the different contexts from which profile details can be navigated to
  SEARCH_PROFILE: (candidateId) => `/path-to-pro-network/search/profile/${candidateId}`,
  DASHBOARD_PROFILE: (candidateId) => `/path-to-pro-network/dashboard/profile/${candidateId}`,
  APPLICANTS_PROFILE: (jobPostingId, candidateId) => `/path-to-pro-network/dashboard/applicants/${jobPostingId}/profile/${candidateId}`
};

export const MY_ACCOUNT_ROUTES = {
  PROFILE: '/myaccount/profile',
  UPGRADE_PROFILE: '/myaccount/profile?plcc-upgrade-flow=true'
};

export const NAV_PATHS = {
  DASHBOARD: 'dashboard',
  SEARCH: 'search'
};

export const JOB_POSTING_STATUS = {
  DRAFT: 'DRAFT',
  ACTIVE: 'ACTIVE',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED'
};

export const JOB_STATUS_JSX_MAP = {
  ACTIVE: <span style={{ color: '#00AE4D' }}>Active</span>,
  DRAFT: <span style={{ color: '#F96302' }}>Draft</span>,
  COMPLETED: <span style={{ color: '#666666' }}>Complete</span>,
  CANCELLED: <span style={{ color: '#D81118' }}>Cancelled</span>
};

export const APPLICANT_STATUS_JSX_MAP = {
  hired: <span style={{ color: '#00AE4D' }} data-testid="hired">Hired</span>,
  not_hired: <span style={{ color: '#D81118' }} data-testid="not_hired">Not Hired</span>,
  applied: <span style={{ color: '#F96302' }} data-testid="applied">Applied</span>,
  invited: <span style={{ color: '#666666' }} data-testid="invited">Invited</span>,
  declined: <span style={{ color: '#666666' }} data-testid="declined">Declined</span>
};

export const DASHBOARD_TABS = {
  RECENTLY_CONTACTED: '0',
  FAVORITES: '1'
};

export const tradeTypeIconMap = {
  Carpentry: 'carpentry',
  'Construction and Remodeling': 'singleFamilyConstruction',
  Electrical: 'electrical',
  'Fire & Water Restoration': 'fireAndWaterRestoration',
  'General Laborer': 'residentialRemodeling',
  Handywork: 'handywork',
  HVAC: 'hvac',
  Landscaping: 'landscaping',
  'Masonry / Concrete': 'masonry',
  Painting: 'painting',
  Plumbing: 'plumbing',
  'Property Investment': 'propertyInvestment',
  'Property Management': 'propertyManagementNonResidential',
  Roofing: 'roofing',
  Welding: 'welding',
  // deprecated below, cleanup after finalized tradetypes
  'Multi-Family Residential Construction': 'multiFamilyConstruction',
  'Non-Residential Construction': 'nonResidentialConstruction',
  'Non-Residential Remodeling': 'nonResidentialHandywork',
  'Property Management Non-Residential': 'propertyManagementNonResidential',
  'Property Management Single and Multifamily': 'propertyManagementSingleMultiAndFamily',
  'Residential Remodeling': 'residentialRemodeling',
  'Single-Family Residential Construction': 'singleFamilyConstruction'
};

export const tradeTypeAbbreviated = {
  'Multi-Family Residential Construction': 'Construction',
  'Non-Residential Construction': 'Construction',
  'Single-Family Residential Construction': 'Construction',
  'Non-Residential Remodeling': 'Remodeling',
  'Residential Remodeling': 'Remodeling',
  'Property Management Non-Residential': 'Property Management',
  'Property Management Single and Multifamily': 'Property Management'
};

export const LOCATION_SESSION_STORAGE_KEY = 'CUSTOMER_GEOLOCATION_INFO';

export const LOCATION_SERVICE_FAILED_LOCAL_TEXT = 'Unable to fetch location, please try a city or zip code';

export const CREATE_JOB_POSTING_DEFAULTS = {
  TRADE_TYPE_BASIC_HEADER: 'Select a Trade type for this job',
  EMPLOYMENT_TYPE_BASIC_HEADER: 'Select part-time, full-time, etc.',
  EXPERIENCE_LEVEL_BASIC_HEADER: 'Select the level of experience',
  PAY_FREQUENCY_BASIC_HEADER: 'Select a pay frequency'
};

export const AUTH_FORM_PATH = '/auth/view/signin';
export const HOME_PAGE_PATH = '/path-to-pro-network';
export const HOME_PAGE_PATH2 = '/network';

export const HOME_PAGE_PATH_ARRAY = [HOME_PAGE_PATH, HOME_PAGE_PATH2, `${HOME_PAGE_PATH}/`, `${HOME_PAGE_PATH2}/`];

export const NAME_CHAR_LIMIT = '50';
export const JOB_TITLE_CHAR_LIMIT = '150';
export const DESCRIPTION_CHAR_LIMIT = '3000';
